/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  Item Category Interface
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface ItemCategoryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface ItemCategory {
  id?:number;
  code:string;
  name:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP:string;
  updatedIP:string;  
  parameters?: ItemCategoryParameter[];
  links?: any;
}
export interface ItemCreditNote {
  id?:number;
  name:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  branchId:any;
  createdIP:string;
  updatedIP:string;  
  parameters?: ItemCategoryParameter[];
  links?: any;
}

export abstract class ItemCategoryData {
  abstract list(url:string): Observable<ItemCategory[]>;
  abstract create(url: string,data: ItemCategory): Observable<any>;
  abstract update(url: string,data: ItemCategory): Observable<any>;
  abstract delete(url: string): Observable<any>;
  //Credit Note
  abstract creditlist(url:string): Observable<ItemCreditNote[]>;
  abstract creditcreate(url: string,data: ItemCreditNote): Observable<any>;
  abstract creditupdate(url: string,data: ItemCreditNote): Observable<any>;
}